const versions = {
  uk: {
    code: "uk",
    currency: "GBP£",
    name: "United Kingdom",
    hostname: "kimai.com",
    currencySign: "£",
    pathname: "uk",
    hrefLang: "en-gb"
  },
  us: {
    code: "us",
    currency: "USD$",
    name: "International",
    hostname: "kimai.com",
    currencySign: "$",
    pathname: "us",
    hrefLang: "en-us"
  },
  eu: {
    code: "eu",
    currency: "EUR€",
    name: "Europe",
    hostname: "kimai.com",
    currencySign: "€",
    pathname: "eu",
    hrefLang: "x-default"
  },
  fr: {
    code: "fr",
    currency: "EUR€",
    name: "France",
    hostname: "kimai.com",
    currencySign: "€",
    pathname: "fr",
    hrefLang: "fr-fr"
  },
};

module.exports = versions
